module.exports = __webpack_public_path__ + "static/media/404.368fe3e8.png";